'use client';

import { c as _c } from "react/compiler-runtime";
import type { BoardListItem } from '@module/apis/client-side/customer/type';
import { cn } from '@module/lib/utils';
import { convertISOToDottedShortDateString } from '@module/utils/date/convertDateFormat';
import { useRouter } from 'next/navigation';
import toast, { type Toast } from 'react-hot-toast';
import ToastBody from '../atoms/toast/ToastBody';
const eventStatus = (progress: string) => {
  switch (progress) {
    case 'end':
      return '종료';
    case 'exp':
      return '예정';
    case 'ing':
      return '진행중';
    default:
      return '';
  }
};
const getEventPeriod = (start: string, end: string) => {
  const formattedStart = convertISOToDottedShortDateString(start);
  const formattedEnd = convertISOToDottedShortDateString(end);
  if (!formattedStart || !formattedEnd) return '';
  return `${formattedStart} ~ ${formattedEnd}`;
};
interface EventCardProps {
  item: BoardListItem;
  currentPage: number;
}
function EventCard(t0) {
  const $ = _c(41);
  const {
    item,
    currentPage
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== currentPage || $[1] !== item.idx || $[2] !== item.link || $[3] !== item.message || $[4] !== item.popupLink || $[5] !== item.type || $[6] !== router) {
    t1 = () => {
      if (item.type === "message") {
        toast(m => <ToastBody id={m.id} content={item.message || ""} />);
      } else {
        if (item.type === "popup" && item.popupLink) {
          window.open(item.popupLink, "_blank", "noopener")?.focus();
        } else {
          if (item.type === "link" && item.link) {
            location.href = item.link;
          } else {
            if (item.type === "view") {
              router.push(`/customer/event/${item.idx}?page=${currentPage}`);
            }
          }
        }
      }
    };
    $[0] = currentPage;
    $[1] = item.idx;
    $[2] = item.link;
    $[3] = item.message;
    $[4] = item.popupLink;
    $[5] = item.type;
    $[6] = router;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleEventClick = t1;
  const t2 = item.progress === "ing";
  const t3 = item.progress !== "ing";
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = cn("absolute top-4 left-4 z-10 rounded-lg px-[14px] py-2 text-[14px] text-white", {
      "bg-[#ef312a]": t2,
      "bg-[#333]": t3
    });
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = item.progress ?? "";
  let t6;
  if ($[11] !== t5) {
    t6 = eventStatus(t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== item.progress) {
    t8 = item.progress === "end" && <div className="absolute top-0 right-0 bottom-0 left-0 bg-black opacity-30" />;
    $[16] = item.progress;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== item.imgListUrl || $[19] !== item.subject) {
    t9 = item.imgListUrl && <img src={item.imgListUrl} alt={item.subject} />;
    $[18] = item.imgListUrl;
    $[19] = item.subject;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="relative overflow-hidden rounded-lg">{t7}{t8}{t9}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== handleEventClick || $[26] !== t10) {
    t11 = <button type="button" onClick={handleEventClick}>{t10}</button>;
    $[25] = handleEventClick;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== item.subject) {
    t12 = <span className="font-[500] text-[20px] text-baseFg" dangerouslySetInnerHTML={{
      __html: item.subject
    }} />;
    $[28] = item.subject;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== item.termEndDateTime || $[31] !== item.termStartDateTime) {
    t13 = getEventPeriod(item.termStartDateTime, item.termEndDateTime);
    $[30] = item.termEndDateTime;
    $[31] = item.termStartDateTime;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = <span className="mt-[2px] text-[#777]">{t13}</span>;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t14) {
    t15 = <div className="mt-3 flex flex-col">{t12}{t14}</div>;
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t11 || $[39] !== t15) {
    t16 = <div className="mb-16 w-[620px]">{t11}{t15}</div>;
    $[38] = t11;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
}
export default EventCard;